// extracted by mini-css-extract-plugin
export var errorIcon = "_qz-1";
export var nameLogo = "_qz-0";